// ── Sandbox localStorage persistence ────────────────────────────────────────
// Thin wrapper with cb_ namespace. No external dependencies.

const NS = 'cb_';

export function loadState<T>(key: string, fallback: T): T {
  try {
    const raw = localStorage.getItem(NS + key);
    return raw ? (JSON.parse(raw) as T) : fallback;
  } catch {
    return fallback;
  }
}

export function saveState<T>(key: string, value: T): void {
  try {
    localStorage.setItem(NS + key, JSON.stringify(value));
  } catch {
    // localStorage full or unavailable — silently fail
  }
}

export function removeState(key: string): void {
  localStorage.removeItem(NS + key);
}

// ── Cross-page notification emitter ─────────────────────────────────────────

interface StoredNotification {
  id: string;
  type: string;
  emoji: string;
  title: string;
  description: string;
  time: string;
  read: boolean;
}

export function emitNotification(notif: Omit<StoredNotification, 'id' | 'read'>): void {
  const existing = loadState<StoredNotification[]>('notifications', []);
  const entry: StoredNotification = {
    ...notif,
    id: `n-${Date.now()}-${Math.random().toString(36).slice(2, 6)}`,
    read: false,
  };
  saveState('notifications', [entry, ...existing]);
}
